// extracted by mini-css-extract-plugin
export var parcelRow = "_qx-0";